// extracted by mini-css-extract-plugin
export default {"social":"SocialLogin_social__emLB6","providerBtn":"SocialLogin_providerBtn__ip-cE","divider":"SocialLogin_divider__yVlZO","consent":"SocialLogin_consent__F+rr1"};